export const POPULAR_BRANDS = [
  'Fresh Prints',
  'Comfort Colors',
  'Champion',
  'Nike',
  'Charles River',
  'Gildan',
  'Adidas',
  'Bella Canvas',
  'The North Face',
  'Vineyard Vines',
  'Southern Tide',
  'Under Armour',
  'Next Level',
  'Alternative',
  'Carhartt',
];

export const POPULAR_BRANDS_LESS = [
  'Fresh Prints',
  'Comfort Colors',
  'Champion',
  'Nike',
  'Charles River',
];
